var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"}},[_c('path',{attrs:{"d":"M0 5H12V7H0V5Z","fill":"black"}}),_c('path',{attrs:{"d":"M5 12L5 8.74228e-08L7 0L7 12H5Z","fill":"black"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }